import React, { Component, Fragment } from 'react';
import { ErrorMessage, Form, Formik, Field } from 'formik';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomSelectWithValues from '../../../../common/formElements/CustomSelectWithValues';
import DynamicOpenModalRule from './DynamicOpenModalRule';
import {
  processRediretRule,
  getFilteredArray,
  collectionOptions,
  collectionFieldOptions,
  getPageOptions,
  getSelectOption,
  createActionSettingsSchema,
} from './util';
import { getFieldInfoByName } from '../collection/Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
export default class DynamicOpenModal extends Component {
  state = {
    params: [],
  };

  componentDidMount = () => {
    const { eventAction, actionData } = this.props;
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'modalOpenRules';
    });
    this.setState({
      params: dbParams
        ? dbParams.value
        : [
            {
              id: 1,
              fieldValue: '',
              modal: '',
            },
          ],
    });
  };

  createNewParamRow = (rowObj) => {
    const params = processRediretRule(this.state.params, rowObj);
    this.setState({ params });
  };

  handlePageChange = (setFieldValue, values, value) => {
    const { pages } = this.props.events;
    const selectedPage = pages.length > 0 ? pages.find((item) => item.slug === value) : null;
    const selectedPagCollection =
      selectedPage && selectedPage.collectionId ? selectedPage.collectionId : '';

    setFieldValue('collectionName', selectedPagCollection);
  };

  handleCollectionChange = (setFieldValue, values, value) => {
    setFieldValue('fieldName', '');
    this.setState({
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
    });
  };

  handleFieldChange = (name, value) => {
    this.setState({
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
    });
  };

  onCollectionFromChange = (setFieldValue, values, value) => {
    if (value === 'session') {
      setFieldValue('collectionName', 'user');
    } else {
      setFieldValue('collectionName', '');
    }
    setFieldValue('collectionFrom', value);
    setFieldValue('fieldName', '');
    setFieldValue('page', '');
    this.setState({
      params: [
        {
          id: 1,
          fieldValue: '',
          modal: '',
        },
      ],
    });
  };

  handleSubmit = (values) => {
    const { actionData } = this.props;
    console.log('valuesss', values);
    const { params } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      console.log('value', value);
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    parameters.push({
      name: 'modalOpenRules',
      value: getFilteredArray(params),
      type: 'array',
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    this.props.actions.updateAction({
      projectId: this.props.projectId,
      version: this.props.version,
      eventId: this.props.selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  render() {
    const { eventAction, actionData, events, projectId, version } = this.props;
    const { snippets, collections } = events || '';
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Data Location"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('modalDataLocation')}
                    >
                      <CustomSelectWithValues
                        name={'collectionFrom'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={getSelectOption()}
                        value={values['collectionFrom']}
                        formValues={values}
                        setFieldValue={setFieldValue}
                        onChangeOption={this.onCollectionFromChange}
                        placeholder={'Get Data From'}
                      />
                      <ErrorMessage name={'collectionFrom'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                </div>

                {values['collectionFrom'] === 'page' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Page"
                        icon="select"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('modalCollectionPage')}
                      >
                        <CustomSelectWithValues
                          name={'page'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={getPageOptions(this.props.events)}
                          value={values['page']}
                          formValues={values}
                          setFieldValue={setFieldValue}
                          onChangeOption={this.handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}

                {values['collectionFrom'] !== 'sessionActionResponse' && (
                  <>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Collection"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('modalDataLocationCollection')}
                        >
                          <CustomSelectWithValues
                            name={'collectionName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={collectionOptions(this.props.events)}
                            value={values['collectionName']}
                            isDisabled={
                              values['collectionFrom'] === 'page' ||
                              values['collectionFrom'] === 'session'
                            }
                            formValues={values}
                            setFieldValue={setFieldValue}
                            onChangeOption={this.handleCollectionChange}
                          />
                        </FormFieldWithLabel>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Field"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('modalCollectionField')}
                        >
                          <CustomSelect
                            name={'fieldName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={collectionFieldOptions(
                              values['collectionName'],
                              this.props.events,
                            )}
                            value={values['fieldName']}
                            onChangeValue={this.handleFieldChange}
                          />
                          <ErrorMessage name={'fieldName'}>
                            {(msg) => <p className="text-error">{msg}</p>}
                          </ErrorMessage>
                        </FormFieldWithLabel>
                      </div>
                    </div>
                  </>
                )}

                {values['collectionFrom'] === 'sessionActionResponse' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Session Field Name"
                        icon="text"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('modalSessionFieldName')}
                      >
                        <Field
                          type={'text'}
                          name={'fieldName'}
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder={'Field Name'}
                        />
                        <ErrorMessage name={'fieldName'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}

                {values['fieldName'] && (
                  <div className="col-12">
                    <label>
                      Modal Opening Rules{' '}
                      {values['collectionFrom'] === 'sessionActionResponse' &&
                        `(For default opening of modal, use keyword DEFAULT or, EMPTY in Field Value)`}
                    </label>
                    <DynamicOpenModalRule
                      createNewParamRow={this.createNewParamRow}
                      params={this.state.params}
                      collectionFrom={values['collectionFrom']}
                      selectedCollectionName={values['collectionName']}
                      selectedFieldName={values['fieldName']}
                      collections={collections}
                      snippets={snippets}
                      projectId={projectId}
                      version={version}
                    />
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="text-right">
                    <div className="float-left">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.props.hideModal}
                      >
                        <span>
                          <i className="wb webconnect-times"></i>&nbsp;Cancel
                        </span>
                      </button>
                    </div>
                    <div className="float-right">
                      <button type="submit" className="btn btn-theme-submit btn-sm">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        <CustomLoader loading={this.props.showLoaderForAction} />
                      </button>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}
